/**
 * Created by lk on 17/6/4.
 */
import axios from "../../utils/axios";


export function userInfo(query) {
    return axios({
        url: "/admin/app/users/user",
        method: "get",
        params: query
    });
}

// 列表
export function usersList(query) {
    return axios({
        url: "/admin/app/users/index",
        method: "get",
        params: query
    });
}

export function userSave(data) {
    return axios({
        url: "/admin/app/users/userSave",
        method: "post",
        data: data
    });
}


export function userSaveExamine(data) {
    return axios({
        url: "/admin/app/users/userSaveExamine",
        method: "post",
        data: data
    });
}

export function userExmineChange(data) {
    return axios({
        url: "/admin/app/users/userExmineChange",
        method: "post",
        data: data
    });
}

export function usersComplaintList(query) {
    return axios({
        url: "/admin/system/complaint/index",
        method: "get",
        params: query
    });
}

export function activeUser(query) {
    return axios({
        url: "/admin/system/complaint/activeUser",
        method: "post",
        data: query
    });
}

export function freezeAccount(query) {
    return axios({
        url: "/admin/system/complaint/freezeAccount",
        method: "post",
        data: query
    });
}

export function changeLoginStatus(query) {
    return axios({
        url: "/admin/app/users/changeLoginStatus",
        method: "get",
        params: query
    });
}

export function normalUsers(query) {
    return axios({
        url: "/admin/app/users/normalUsers",
        method: "get",
        params: query
    });
}

export function doctorUsers(query) {
    return axios({
        url: "/admin/app/users/doctorUsers",
        method: "get",
        params: query
    });
}

export function consultantUsers(query) {
    return axios({
        url: "/admin/app/users/consultantUsers",
        method: "get",
        params: query
    });
}

export function audit(query) {
    return axios({
        url: "/admin/app/users/auditUser",
        method: "post",
        data: query
    });
}

export function goods(query) {
    return axios({
        url: "/admin/app/users/relationProduct",
        method: "get",
        params: query
    });
}

export function jobDesc(query) {
    return axios({
        url: "/admin/app/users/jobDesc",
        method: "get",
        params: query
    });
}

export function serviceOrganizationUsers(query) {
    return axios({
        url: "/admin/app/users/serviceOrganizationUsers",
        method: 'get',
        params: query
    });
}

export function userDel(query) {
    return axios({
        url: "/admin/app/users/del",
        method: 'get',
        params: query
    });
}

export function userCount(query) {
    return axios({
        url: "/admin/app/users/userCount",
        method: "get",
        params: query
    });
}

export function userEarn(query) {
    return axios({
        url: "/admin/app/users/earn",
        method: "get",
        params: query
    });
}

export function userRebate(query) {
    return axios({
        url: "/admin/app/users/notUsedRebate"
    });
}

